<template>
    <div id="recommend">
        <transition name="scale">
            <div class="centerPanel">
                <div class="con">
                    <div class="full">
                        <div class="alert_title flex jb ac">
                            <p>选择分类<span>（请选择1-3个类型）</span></p>
                            <img src="./img/close.png"
                                 @click="close"
                                 class="close" />
                        </div>
                        <div class="tips">推荐的作品将在绘画广场展示，并且也有可能推荐给类似关键词的用户</div>
                        <div class="list flex">
                            <div class="item"
                                 :class="item.active?'active':''"
                                 @click="choose_item(index)"
                                 v-for="(item, index) in cate_list"
                                 :key="index">
                                {{item.name}}
                            </div>
                        </div>

                        <div class="btn">
                            <span @click="submit">推荐到广场</span>
                        </div>
                    </div>
                </div>
            </div>
        </transition>

    </div>
</template>

<script>
export default {
    props: ['draw_item'],
    data () {
        return {
            cate_list: [],
        }
    },
    created () {
        this.$http.get(`/front/aimj/draw/cate/`).then((res) => {
            let _list = res.data.item_list
            _list.forEach(e => {
                e.active = false
                
            });
            if(_list.length > 0)
                _list[0].active = true
            this.cate_list = _list
        })
    },
    computed: {

    },
    methods: {
        choose_item (index) {
            this.cate_list[index].active = true
            this.sys_cate_id = this.cate_list[index].id
            this.cate_list.forEach(e => {
                if(this.cate_list[index].id !== e.id)
                    e.active = false
            })
        },
        //关闭弹窗
        close () {
            this.content = ''
            this.$emit('close', this.draw_item.draw_id)
        },
        //提交
        submit () {
            //进行网络请求
            this.$http.patch(`/front/aimj/user/draw/${this.draw_item.draw_id}/`, {'action':'public', data:{'sys_cate_id':this.sys_cate_id}}).then((res) => {
                this.$message({
                        message: '推荐成功',
                        type: 'success'
                    });
            }).finally((res) => {
                this.close()
            })
        }
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
#recommend {
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 1501;
    bottom: 0;
    left: 0;
    transition: all 0.3s;
    background: rgba(0, 0, 0, 0.8);
    overflow: auto;
    animation: fadeInSlowAni 0.3s 1;
    .centerPanel {
        position: fixed;
        z-index: 1501;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        transition: transform 0.2s;
        .con {
            width: 360px;
            max-width: 90vw;
            padding: 20px 15px;
            background-color: #1e1f22;
            border-radius: 6px;
            border: 2px solid #5865f2;
            .full {
                position: relative;
                display: flex;
                flex-direction: column;
                height: 100%;
                .alert_title {
                    p {
                        font-size: 14px;
                        color: #fff;
                        span {
                            font-size: 12px;
                            color: #aaa;
                        }
                    }
                    .close {
                        width: 16px;
                        height: 16px;
                        cursor: pointer;
                    }
                }
                .tips {
                    font-size: 14px;
                    margin-top: 10px;
                    color: #d6d6d6;
                    white-space: pre-wrap;
                }
                .list {
                    margin: 10px 0;
                    flex-wrap: wrap;
                    .item {
                        cursor: pointer;
                        margin: 8px 5px;
                        padding: 0 20px;
                        color: #fff;
                        background: #444;
                        font-size: 12px;
                        line-height: 34px;
                        border: 2px solid #323335;
                        border-radius: 8px;
                        &.active {
                            border-color: #5865f2;
                        }
                    }
                }
                .btn {
                    span {
                        display: block;
                        margin: 20px 40px 0 40px;
                        border-radius: 10px;
                        cursor: pointer;
                        background-color: #5865f2;
                        color: #fff;
                        border-radius: 10rpx;
                        height: 50px;
                        line-height: 50px;
                        text-align: center;
                        font-size: 16px;
                        &:hover {
                            opacity: 0.8;
                        }
                    }
                }
            }
        }
    }
}

.scale-enter-active,
.scale-leave-active {
    transition: all 0.3s;
}
.scale-enter,
.scale-leave-to {
    transform: translate(-50%, -50%) scale(0.6);
    opacity: 0;
}
</style>